// extracted by mini-css-extract-plugin
export var circle = "PolarCircle-module--circle--Lnx61";
export var spin = "PolarCircle-module--spin--WGdWi";